.app-title {
    display: inline;
    font-family: 'Open Sans Semibold';
    color: #fff;
    margin: 0;
    font-size: 20px;
}